import { useContext } from 'react'

import { ClusterContext } from './context'

export const useCreatorClusters = () => useContext(ClusterContext)
